import React, {useState} from 'react';
import DynamicImageGallery from '../dynamic-image-gallery/dynamic-image-gallery.jsx';

import './gallery-slide.css'

const GallerySlide = ({images = [], title="Title", showThumbnails=false})=> {

    return <DynamicImageGallery 
            items={images} 
            showThumbnails={showThumbnails} 
        />

}

export default GallerySlide;